// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__MgHWM","colMaxWidth":"Table_colMaxWidth__1oIWq"};